import RegistrationForm from "@/components/site/RegistrationForm";
import ContactOurTeam from "@/components/site/ContactOurTeam";
import usePageTitle from "@/hooks/usePageTitle";

export default function ContactPage() {
  usePageTitle("Contact Our Team · Maqam Community Initiatives");
  return (
    <div data-testid="page-contact">
      <section className="relative pt-32 md:pt-40 pb-8 md:pb-12 bg-white">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <span className="overline">Contact &amp; Registration</span>
          <h1 className="font-serif text-5xl md:text-7xl text-[color:var(--maqam-navy)] mt-3 leading-[1.02] tracking-tight max-w-3xl">
            Begin the journey.<br />Reach out to Maqam.
          </h1>
          <p className="mt-6 text-[var(--maqam-muted)] max-w-2xl leading-relaxed">
            Whether you're registering interest in October 2026 or asking about our
            community programs — our team is a phone call, message, or email away.
          </p>
        </div>
      </section>
      <ContactOurTeam />
      <RegistrationForm />
      <RegistrationForm variant="contact" />
    </div>
  );
}
